import { PostHogClient } from "../../../utils/posthog";
import { FeatureFlagIdentificationService } from "../../application";

export class PostHogFeatureFlagIdentificationService extends FeatureFlagIdentificationService {
  identify(userId: string, userProperties: Record<string, string>): void {
    PostHogClient().identify(userId, userProperties);
  }

  reset(): void {
    PostHogClient().reset();
  }
}
